<template>
  <div>
    <div v-if="badBrowser" class="bad-browser bg-danger w-100">
      Chrome Version >= 79 is need to run L&amp;M Connect correctly.
      ({{ `${browser.name} ${browser.version}` }})
    </div>
    <loading :show="loading && authenticated"></loading>
    <div v-if="authenticated">
      <nav class="navbar navbar-dark fixed-top bg-cx3 flex-md-nowrap p-0">
        <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">
          <img
            src="https://lm-web-assets.s3.us-east-2.amazonaws.com/img/lmc-logo-white.png"
            alt="L&amp;M Connect"
            style="height: 25px;"
          >
        </a>
        <input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search">
        <ul class="navbar-nav px-3">
          <li class="nav-item text-nowrap">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ user.name }}
            </a>
            <div class="dropdown-menu fade" aria-labelledby="navbarDropdown">
              <!-- <a class="dropdown-item" href="#">Action</a> -->
              <!-- <a class="dropdown-item" href="#">Another action</a> -->
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click="logout">Logout</a>
              <div class="dropdown-divider"></div>
              <small class="dropdown-item">{{ browser.name }}<br />{{ browser.version }}</small>
            </div>
          </li>
        </ul>
      </nav>

      <div class="container-fluid">
        <div class="row">
          <nav class="col-md-2 d-none d-md-block bg-cx1 sidebar">
            <div class="sidebar-sticky">
              <ul class="nav flex-column">
                <li class="nav-item">
                  <router-link class="nav-link" to="/dashboard">
                    <i class="fa fa-home bg-default"></i>
                    Dashboard
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/clients">
                    <i class="fa fa-users bg-info"></i>
                    Clients
                  </router-link>
                </li>
              </ul>
              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>WAREHOUSE</span>
              </h6>
              <ul class="nav flex-column">
                <li class="nav-item">
                  <router-link class="nav-link" to="/inbound">
                    <i class="fa fa-truck-loading bg-success"></i>
                    Inbound
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/outbound">
                    <i class="fa fa-shipping-fast bg-danger"></i>
                    Outbound
                  </router-link>
                </li>            
              </ul>

              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Transportation</span>
              </h6>
              <ul class="nav flex-column">
                <li class="nav-item">
                  <router-link class="nav-link" to="/special-orders">
                    <i class="fa fa-wine-glass bg-orange"></i>
                    Special Orders
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/transport">
                    <i class="fa fa-truck bg-orange1"></i>
                    Dispatch
                  </router-link>
                </li>
              </ul>
              
              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Billing</span>
              </h6>
              <ul class="nav flex-column">
                <li class="nav-item">
                  <router-link class="nav-link" to="/invoices">
                    <i class="fa fa-dollar-sign bg-mint"></i>
                    Invoices
                  </router-link>
                </li>
              </ul>

              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Other</span>
              </h6>
              <ul class="nav flex-column">
                <!-- <li class="nav-item">
                  <router-link class="nav-link" to="/settings">
                    <i class="fa fa-tools bg-purple"></i>
                    Settings
                  </router-link>
                </li> -->
                <li class="nav-item">
                  <a class="nav-link" target="_blank" href="https://c2.lmdelivers.com/labels">
                    <i class="fa fa-tags bg-primary"></i>
                    Label Maker
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <main role="main" class="col-md-9 ml-sm-auto col-lg-10 bg-light">
            <router-view></router-view>
          </main>
        </div>
      </div>
    </div>
    <div v-else>
      <login @auth="auth"></login>
    </div>
  </div>
</template>

<script>
import Login from '@/views/Login.vue'
import Loading from '@/views/Loading.vue'
import auth from '@/libs/auth'
import store from '@/stores/app'
import user from '@/libs/user'

import Bowser from 'bowser'
import $ from 'jquery'

import api from '@/api'

export default {
  components: {
    Login,
    Loading,
  },

  data() {
    return {
      loading: true,
      authenticated: false,
    }
  },

  created() {
    if(auth.hasToken()){
      this.auth(true)
      api.get('/ping')
      setInterval(() => {
        api.get('/ping').catch()
      }, 13000);
    }
  },

  computed: {
    user() {
      return store.state.user
    },

    browser() {
      const browser = Bowser.getParser(window.navigator.userAgent)
      return browser.getBrowser()
    },

    badBrowser() {
      return false // this.browser.name != 'Chrome' || parseInt(this.browser.version) < 79
    }
  },

  methods: {
    showSidebar() {
      $('.sidebar').toggleClass('d-block')
    },

    load() {
      const p1 = user.me().then(res =>{
        store.setUser(res.data.user)
      })
      const p2 = new Promise((res) => {
        setTimeout(res, 13)
      })
      Promise.all([p1, p2]).then(() => {
        this.loading = false
      });
    },

    auth(auth) {
      this.authenticated = auth
      if(auth) {
        setTimeout(() => { this.load() }, 500)
      }
    },

    logout() {
      auth.setToken('')
      store.setUser({})
      this.authenticated = false;
    }
  }
}
</script>

<style>

html,
body {
  height: 100vh;
  overflow: hidden;
}

body {
  font-size: 14px; 
  font-family: 'Open Sans', sans-serif;
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(238, 243, 255, 0.349);
}

.nav-tabs .nav-item {
    margin-bottom: -2px;
}

.table th {
  border-top: none;
}

.bg-cx1 {
  background: #0F1723;
}

.bg-cx2 {
  background: #151F2F;
}

.bg-cx3 {
  background: #1B273B;
}

.bg-light {
  background: #F6FAFB;
}

.notie-container {
  box-shadow: none;
}
.notie-background-success {
  background: #27A745;
}

</style>

<style scoped>
  .bad-browser {
    position: fixed;
    bottom: 0;
    height: 48px;
    width: 100vw;
    z-index: 9999999;
    text-align: center;
    padding: 10px;
    font-weight: 600;
    color: #fff;
  }
  .nav-link.active {
    background:#1B273B;
    color: #fff;
  }

  .dropdown-menu {
    position: absolute;
    right: 10px;
    left: auto;
  }

  .fa {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    border-radius: 10px;
    background: #999;
    text-align: center;
    padding-top: 9px;
    margin-right: 7px;
  }

  .bg-orange {
    background: rgb(235, 154, 5);
  }
  .bg-orange1 {
    background: rgb(131, 16, 112);
  }
  .bg-purple {
    background: rgb(76, 0, 163);
  }

  .bg-mint {
    background: #16A085;
  }

  /*
 * Sidebar
 */

  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    /* Behind the navbar */
    padding: 48px 0 0;
    /* Height of navbar */
    /* box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1); */
  }

  .sidebar-sticky {
    opacity: 1;
    position: relative;
    top: 0;
    height: calc(100vh - 48px);
    padding-top: .5rem;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
  }

  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
    }
  }

  .sidebar .nav-link {
    font-weight: 500;
    color: #FFF;
  }

  .sidebar-heading {
    font-size: .75rem;
    text-transform: uppercase;
  }

  /*
 * Content
 */

  [role="main"] {
    padding-top: 48px;
    height: 100vh;
    overflow-y: auto;
    /* Space for fixed navbar */
  }

  /*
 * Navbar
 */
  .navbar {
    height: 48px;
    border-bottom: 1px solid #0F1723;
  }

  .navbar-brand {
    padding-top: 0;
    padding-bottom: 0;
    font-size: 1rem;
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
  }

  .navbar .form-control {
    padding: .75rem 1rem;
    border-width: 0;
    border-radius: 0;
  }

  .form-control-dark {
    color: #fff;
    background: none;
    border: none;
  }

  .form-control-dark:focus {
    border-color: transparent;
    box-shadow: 0 0 0 0 rgba(255, 255, 255, .25);
  }
</style>